import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../../../../../components/ui/alert-dialog'
import { Button } from '../../../../../../../components/ui/button'
import { useEnableAndDisableCardController } from './useEnableAndDisableCardController'

export const EnableAndDisableCard = ({
  isActive,
  id,
}: {
  isActive: boolean
  id: string
}) => {
  const {
    disableIsPending,
    enableIsPending,
    handleIsActive,
    handleIsNotActive,
  } = useEnableAndDisableCardController()

  return (
    <AlertDialogContent className="w-96">
      <AlertDialogHeader>
        <AlertDialogTitle>
          Você quer realmente {isActive ? 'desabilitar' : 'habilitar'} essa
          tabela?
        </AlertDialogTitle>
      </AlertDialogHeader>
      <AlertDialogFooter className="flex items-center">
        <AlertDialogCancel>Cancelar</AlertDialogCancel>
        <AlertDialogAction asChild>
          <Button
            type="submit"
            disabled={isActive ? disableIsPending : enableIsPending}
            onClick={
              isActive ? () => handleIsNotActive(id) : () => handleIsActive(id)
            }
            className="my-4 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
          >
            {isActive ? 'Desabilitar' : 'Habilitar'}
          </Button>
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  )
}
